// @ts-nocheck
import * as constants from "@/constant.js";
import Design from "@/models/Design";
import Line from "@/models/Line";
import PointCloud from "@/models/PointCloud";
import {
	set2DViewFromCurrentPosition,
	set3DView,
	setTopViewCameraToObject,
} from "@/utils/cesium-common";
import { fetchMeV2 } from "@/api/startupApi";
import { selectByMigration } from "@/config/v2Migration";
import axios from "axios";
import { markRaw } from "vue";
import Vuex from "vuex";
import { RubbingDestination } from "../constant";
import localDb from "../utils/local-db";
import addRoadTerrainByAi from "./modules/add-road-terrain-by-ai";
import arbitraryLine from "./modules/arbitrary-line";
import dialogs from "./modules/dialogs";
import drawing2dImage from "./modules/drawing-2d-image";
import dxf from "./modules/dxf";
import lineWorksCenterline from "./modules/lineworks-centerline";
import lineWorksCrossSection from "./modules/lineworks-cross-section";
import lock from "./modules/lock";
import measurement from "./modules/measurement";
import simaLine from "./modules/sima-line";
import object from "./modules/object";
import inProgressModeManager, {
	InProgressMode,
} from "./modules/inprogress-mode-manager";
import aiRoad from "./modules/ai-road";
import flatGround from "./modules/flat-ground";
import {
	type EarthBrainViewer,
	RoadSavedData,
	type ISavedRoadData,
} from "earthbrain-viewer";
import { compareDateByType } from "@/components/Project/listOrdering";
import {
	DEFAULT_SITE_UNITS,
	normalizeSiteUnitSettings,
} from "@/models/siteUnit.types";
import solidMesh from "./modules/solid-mesh";
import spreadingCompaction from "./modules/spreading-compaction";
import toolPanelActions from "./modules/tool-panel-actions";

const store = Vuex.createStore({
	state: {
		panelName: "",
		authObject: {
			username: "2022scdesign",
			password: "passscdesign",
		},
		site: null,
		point_cloud_list: [],
		design_list: [],
		// activeData: [], // アクティブ状態の点群と設計を1つずつ保持
		axis: "",
		user: null,
		lang: "ja",
		roadParameterSlopeUnit: {
			// 勾配単位（道路・摺り付け）
			gradientArea: "percent", // 勾配範囲
			crossSlope: "percent", // 横断勾配
			superElevation: "percent", // 片勾配
			longitudinalSlope: "percent",
		},
		trenchParameterSlopeUnit: {
			gradientArea: "percent",
			crossSlope: "percent",
			superElevation: "percent",
		},
		cutSettingSlopeUnit: {
			// 勾配単位（切土設定）
			slopeGradient: "ratio", // 法面勾配
			bermGradient: "percent", // 小段勾配
		},
		trenchCutSettingSlopeUnit: {
			slopeGradient: "ratio",
			bermGradient: "percent",
		},
		trenchLongitudinalSlopeUnit: "percent",
		fillSettingSlopeUnit: {
			// 勾配単位（盛土設定）
			slopeGradient: "ratio", // 法面勾配
			bermGradient: "percent", // 小段勾配
		},
		longitudinalSectionViewerSlopeUnit: {
			// 勾配単位（縦断ビュー）
			nextGradient: "percent", // 次地点までの勾配
		},
		crossSectionViewerSlopeUnit: {
			// 勾配単位（断面ビュー）
			slopeGradient: "ratio", // 法面勾配
			bermGradient: "percent", // 小段勾配
		},
		// visiblePointCloudAndDesignList: [], // 表示中の点群/設計リスト
		activeLineCrossSection: null, // 最後に表示操作を行った線形断面
		activeSectionMarkerLabel: "", // 断面ビューに表示中の断面位置の名称（測点/BC-EC/BP/EP/NO.X+Y）
		chartBoardCurrentTab: {}, // チャートボードでActive状態のタブ
		draggedTab: {},
		propertyDialog: false,
		// modes: {
		// 	inCreationMode: {
		// 		isActive: false, // 作成モードかどうか
		// 		objectType: null, // 作成オブジェクトのタイプ
		// 	},
		// 	inEditMode: {
		// 		isActive: false, // 編集モードかどうか
		// 		editTargetId: null, // 編集オブジェクトのID
		// 	},
		// 	ai_road_point_selection: false,
		// 	isFlatGroundHoriDrag: false,
		// 	isFlatGroundVertiDrag: false,
		// 	isFlatGroundUniformDrag: false,
		// 	inEditDrawing2dImage: {
		// 		isActive: false, // Whether or not in editing
		// 		editTargetId: null, // The ID of editing image
		// 	},
		// },
		// objects: [],
		isObjectUpdating: false,
		snackbars: [],
		isLoading: false,
		// ai_road_preview_data: {
		// 	x1: undefined,
		// 	y1: undefined,
		// 	z1: undefined,
		// 	x2: undefined,
		// 	y2: undefined,
		// 	z2: undefined,
		// 	startPointHeightAbovePointCloud: undefined,
		// 	startPointHeightAboveDesignData: undefined,
		// 	endPointHeightAbovePointCloud: undefined,
		// 	endPointHeightAboveDesignData: undefined,
		// },
		initial_site_data: {},
		isExclusion: false,
		viewer: undefined,
		is_crs_conversion_in_progress: false,
		conflictCoordinateSystem: null,
		currentView: "3d",
	},
	mutations: {
		set_viewer(state, viewer) {
			state.viewer = markRaw(viewer);
		},
		change_panel(state, panelName) {
			state.panelName = panelName;
		},
		// set_modes(state, name_value) {
		// 	state.modes[name_value.name] = name_value.value;
		// },
		// set_ai_road_preview_data(state, obj) {
		// 	state.ai_road_preview_data.x1 = obj.x1;
		// 	state.ai_road_preview_data.y1 = obj.y1;
		// 	state.ai_road_preview_data.z1 = obj.z1;
		// 	state.ai_road_preview_data.x2 = obj.x2;
		// 	state.ai_road_preview_data.y2 = obj.y2;
		// 	state.ai_road_preview_data.z2 = obj.z2;
		// 	state.ai_road_preview_data.startPointHeightAbovePointCloud =
		// 		obj.startPointHeightAbovePointCloud;
		// 	state.ai_road_preview_data.startPointHeightAboveDesignData =
		// 		obj.startPointHeightAboveDesignData;
		// 	state.ai_road_preview_data.endPointHeightAbovePointCloud =
		// 		obj.endPointHeightAbovePointCloud;
		// 	state.ai_road_preview_data.endPointHeightAboveDesignData =
		// 		obj.endPointHeightAboveDesignData;
		// },
		// set_ai_road_preview_data_property(state, property) {
		// 	state.ai_road_preview_data[property.name] = property.value;
		// },
		// reset_ai_road_preview_data(state) {
		// 	state.ai_road_preview_data = {
		// 		x1: undefined,
		// 		y1: undefined,
		// 		z1: undefined,
		// 		x2: undefined,
		// 		y2: undefined,
		// 		z2: undefined,
		// 		startPointHeightAbovePointCloud: undefined,
		// 		startPointHeightAboveDesignData: undefined,
		// 		endPointHeightAbovePointCloud: undefined,
		// 		endPointHeightAboveDesignData: undefined,
		// 	};
		// },
		setSite(state, site) {
			state.site = site;
		},
		set_point_cloud_list(state, point_cloud_list) {
			state.point_cloud_list = point_cloud_list;
		},
		set_point_cloud_loading(state, point_cloud_id) {
			const index = state.point_cloud_list.findIndex(
				(item) => item.point_cloud_id == point_cloud_id,
			);
			state.point_cloud_list[index].loading = true;
		},
		delete_point_cloud(state, point_cloud_id) {
			const index = state.point_cloud_list.findIndex(
				(item) => item.point_cloud_id == point_cloud_id,
			);
			state.point_cloud_list.splice(index, 1);
		},
		set_design_list(state, design_list) {
			state.design_list = design_list;
		},
		set_design_loading(state, design_id) {
			const index = state.design_list.findIndex(
				(item) => item.design_id == design_id,
			);
			state.design_list[index].loading = true;
		},
		// 線形データ
		set_lineworks_loading(state, lineworks_id) {
			const index = state.design_list.findIndex(
				(item) => item._id === lineworks_id,
			);
			if (index !== -1) {
				state.design_list[index].loading = true;
			}
		},
		add_design(state, design) {
			switch (design.data_type) {
				case "design": {
					state.design_list.push(
						new Design(
							design.data_type,
							design.design_id,
							design.design_name,
							design.asset_id,
							design.color,
							design.transparency,
							design.processing_status,
							design.processing_error,
							design.created_at,
							design.selected_date,
							design.selected_time,
						),
					);
					break;
				}
				case "lineworks": {
					state.design_list.push(
						new Line(
							design.data_type,
							design.lineworks_id,
							design.lineworks_name,
							design.lineworks_path,
							design.processing_status,
							design.create_at,
							design.site_id,
							design.line_type,
						),
					);
					break;
				}
			}
		},
		delete_design(state, design_id) {
			state.design_list = state.design_list.filter(
				(item) => item.design_id != design_id,
			);
		},
		// 線形データ
		delete_lineworks(state, lineworks_id) {
			state.design_list = state.design_list.filter(
				(item) => item._id != lineworks_id,
			);
		},
		setUser(state, user) {
			state.user = user;
			this.commit("setLang");
		},
		setLang(state) {
			if (state.user.language === "en-US") {
				state.lang = "en";
			} else {
				state.lang = state.user.language;
			}
		},
		setChartBoardCurrentTab(state, tab) {
			state.chartBoardCurrentTab = tab;
		},
		setDraggedTab(state, tab) {
			state.draggedTab = tab;
		},
		togglePropertyDialog() {
			this.state.propertyDialog = !this.state.propertyDialog;
		},
		toggleRoadParameterSlopeUnit(state, property) {
			for (const key of Object.keys(property)) {
				state.roadParameterSlopeUnit[key] = property[key];
			}
		},
		toggleCutSettingSlopeUnit(state, property) {
			for (const key of Object.keys(property)) {
				state.cutSettingSlopeUnit[key] = property[key];
			}
		},
		toggleTrenchParameterSlopeUnit(state, property) {
			for (const key of Object.keys(property)) {
				state.trenchParameterSlopeUnit[key] = property[key];
			}
		},
		toggleTrenchCutSettingSlopeUnit(state, property) {
			for (const key of Object.keys(property)) {
				state.trenchCutSettingSlopeUnit[key] = property[key];
			}
		},
		toggleTrenchLongitudinalSlopeUnit(state, unit) {
			state.trenchLongitudinalSlopeUnit = unit;
		},
		toggleFillSettingSlopeUnit(state, property) {
			for (const key of Object.keys(property)) {
				state.fillSettingSlopeUnit[key] = property[key];
			}
		},
		setObjectUpdating(state, value) {
			state.isObjectUpdating = value;
		},
		// setVisiblePointCloudAndDesignList(state, pointCloudList) {
		// 	state.visiblePointCloudAndDesignList = pointCloudList;
		// },
		setActiveLineCrossSection(state, line) {
			state.activeLineCrossSection = line;
		},
		setActiveSectionMarkerLabel(state, label) {
			state.activeSectionMarkerLabel = label || "";
		},
		// setActiveData(state, data) {
		// 	state.activeData = data;
		// },
		set_snackbar(state, snackbar) {
			snackbar.showing = true;
			snackbar.id = "notification_" + Date.now();
			state.snackbars.push(snackbar);
		},
		hide_snackbars(state, ids) {
			const idSet = new Set(ids);
			for (const snackbar of state.snackbars) {
				if (idSet.has(snackbar.id)) {
					snackbar.showing = false;
				}
			}
		},
		clear_snackbars(state) {
			state.snackbars = state.snackbars.filter((snackbar) => {
				return snackbar.showing == true;
			});
		},
		reset_snackbars(state) {
			state.snackbars = [];
		},
		setLoading(state, isLoading) {
			state.isLoading = isLoading;
		},
		set_initial_site_datas(state, ret) {
			state.initial_site_data = ret;
		},
		set_exclusion(state, flag) {
			state.isExclusion = flag;
		},
		set_conflict_coordinate_system(state, data) {
			state.conflictCoordinateSystem = data;
		},
		set_current_view(state, view) {
			state.currentView = view;
		},
	},
	actions: {
		syncViewerUnit({ state }) {
			const viewer = state.viewer;
			if (!viewer) return;
			if (typeof viewer.getViewerUnit !== "function") return;
			if (typeof viewer.updateViewerUnit !== "function") return;

			const targetUnit =
				state.site?.units?.distance ?? DEFAULT_SITE_UNITS.distance;
			if (viewer.getViewerUnit() === targetUnit) {
				return;
			}

			viewer.updateViewerUnit(targetUnit);
		},

		getSiteInfo({ state, commit, dispatch }, siteId) {
			return axios
				.get(`${import.meta.env.VITE_API_BASE}/sites/${siteId}`, {
					auth: state.authObject,
				})
				.then((response) => {
					const siteData = {
						...response.data,
						units: normalizeSiteUnitSettings(response.data?.unit),
					};
					commit("setSite", siteData);
					dispatch("syncViewerUnit");
					if (
						response?.data?.obj_connection_json &&
						response.data.obj_connection_json !== ""
					) {
						state.viewer.loadConnectionsInSiteJSON(
							response.data.obj_connection_json,
						);
					}
				})
				.catch((err) => {
					console.error("GET SITE INFO", err);
					throw err;
				});
		},
		setActiveLineCrossSection({ commit }, line) {
			commit("setActiveLineCrossSection", line);
		},
		setActiveLineCrossSectionById({ commit }, lineId) {
			const findLineEntityByLieId = (viewerLineId) => {
				const foundInArbitrary =
					store.state.arbitraryLine.arbitraryLineList.find(
						(item) => item.viewerLineId === viewerLineId,
					);

				if (foundInArbitrary) {
					return foundInArbitrary;
				}

				const foundInSima = store.state.simaLine.simaLineList.find(
					(item) => item.viewerLineId === viewerLineId,
				);
				return foundInSima;
			};
			const line = findLineEntityByLieId(lineId);
			commit("setActiveLineCrossSection", line);
		},
		changePanel(context, panelName) {
			context.commit("change_panel", panelName);
		},
		getUser() {
			return selectByMigration("startup", {
				v1: () =>
					axios
						.get(`${import.meta.env.VITE_API_BASE}/user/me`, {
							auth: this.state.authObject,
						})
						.then((res) => res.data),
				v2: fetchMeV2,
			})().then((user) => {
				this.commit("setUser", user);
			});
		},
		updateInitialSiteInfo({ state, commit }, siteId) {
			axios
				.get(`${import.meta.env.VITE_API_BASE}/sites/${siteId}`, {
					auth: state.authObject,
				})
				.then((res) => {
					const updateInfo = res ? res.data : null;
					commit("set_initial_site_datas", updateInfo);
				});
		},
		async get_point_cloud_list({ state, commit }, site_id) {
			const pointCloudList = [];
			const res = await axios.get(
				`${import.meta.env.VITE_API_BASE}/pointcloud/${site_id}`,
				{
					auth: state.authObject,
				},
			);
			for (const pointCloud of res.data) {
				const currentPointCloud = state.point_cloud_list.find(
					(entity) => entity.getId() === pointCloud.point_cloud_id,
				);
				// すでにリストに存在する場合は更新。そうでない場合は新規追加
				if (currentPointCloud) {
					currentPointCloud.update(pointCloud);
					pointCloudList.push(currentPointCloud);
				} else {
					const newPointCloud = new PointCloud(
						pointCloud.point_cloud_id,
						pointCloud.point_cloud_name,
						pointCloud.asset_id,
						pointCloud.transparency,
						pointCloud.processing_status,
						pointCloud.processing_error,
						pointCloud.create_at,
						pointCloud.updated_at,
						pointCloud.selected_date,
						pointCloud.selected_time,
						pointCloud.axis,
					);
					pointCloudList.push(newPointCloud);
				}
			}
			pointCloudList.sort(compareDateByType);
			commit("set_point_cloud_list", pointCloudList);
		},
		async delete_point_cloud({ state, commit }, { point_cloud_id, asset_id }) {
			commit("set_point_cloud_loading", point_cloud_id);
			await axios.delete(`${import.meta.env.VITE_API_BASE}/pointcloud`, {
				data: {
					point_cloud_id,
				},
			});
			state.viewer.removeTileset(Number.parseInt(asset_id), "pointcloud");
			localDb.deletePointCloud(state.user.id, state.site.site_uuid, asset_id);
			commit("delete_point_cloud", point_cloud_id);
		},
		async get_design_list({ state, commit }, site_id) {
			const designList = [];

			try {
				const designs = await axios.get(
					`${import.meta.env.VITE_API_BASE}/design/${site_id}`,
					{
						auth: this.state.authObject,
					},
				);
				for (const design of designs.data) {
					const currentDesign = state.design_list.find(
						(entity) => entity.getId() === design.design_id,
					);
					if (currentDesign) {
						currentDesign.update(design);
						designList.push(currentDesign);
					} else {
						const newDesign = new Design(
							"design",
							design.design_id,
							design.design_name,
							design.asset_id,
							design.color,
							design.transparency,
							design.processing_status,
							design.processing_error,
							design.create_at,
							design.selected_date,
							design.selected_time,
						);
						designList.push(newDesign);
					}
				}
			} catch (e) {
				// Todo display appropriate message
				console.warn(e);
			}

			try {
				const dxfLines = await axios.get(
					`${import.meta.env.VITE_API_BASE}/lineworks/all/${site_id}`,
					{
						auth: this.state.authObject,
					},
				);

				for (const dxfLine of dxfLines.data) {
					const currentLine = state.design_list.find(
						(entity) => entity.getId() === dxfLine.lineworks_id,
					);
					if (currentLine) {
						currentLine.update(dxfLine);
						designList.push(currentLine);
					} else {
						const newLine = new Line(
							"lineworks",
							dxfLine.lineworks_id,
							dxfLine.lineworks_name,
							dxfLine.lineworks_path,
							dxfLine.processing_status,
							dxfLine.create_at,
							dxfLine.site_id,
							"dxf",
						);
						designList.push(newLine);
					}
				}
			} catch (e) {
				// Todo display appropriate message
				console.warn(e);
			}

			designList.sort(compareDateByType);

			commit("set_design_list", designList);
		},
		// 設計データ削除
		async delete_design({ state, commit }, { design_id, asset_id }) {
			commit("set_design_loading", design_id);
			try {
				await axios.delete(`${import.meta.env.VITE_API_BASE}/design`, {
					data: { design_id },
				});
				state.viewer.removeTileset(Number.parseInt(asset_id), "design");
				localDb.deleteDesign(state.user.id, state.site.site_uuid, asset_id);

				commit("delete_design", design_id);
				return { success: true, message: "Design deleted successfully." };
			} catch (error) {
				console.error("Error deleting design:", error);
				return { success: false, message: "Error deleting design." };
			}
		},
		// 線形データ削除
		async delete_lineworks({ state, commit }, { _id, _lineType }) {
			const lineworksId = _id;
			commit("set_lineworks_loading", lineworksId);
			try {
				if (_lineType === "dxf") {
					await axios.delete(
						`${import.meta.env.VITE_API_BASE}/lineworks/${lineworksId}`,
					);
				} else if (_lineType === "sima") {
					await axios.delete(
						`${import.meta.env.VITE_API_BASE}/linearfile/${state.site.site_uuid}/${lineworksId}`,
					);
				}

				commit("delete_lineworks", lineworksId);
				return { success: true, message: "Linework deleted successfully." };
			} catch (error) {
				console.error("Error deleting design:", error);
				return { success: false, message: "Error deleting linework." };
			}
		},
		startObjectUpdating({ commit }) {
			commit("setObjectUpdating", true);
		},
		endObjectUpdating({ commit }) {
			commit("setObjectUpdating", false);
		},
		toggleRoadParameterSlopeUnit({ commit }, property) {
			commit("toggleRoadParameterSlopeUnit", property);
		},
		toggleTrenchParameterSlopeUnit({ commit }, property) {
			commit("toggleTrenchParameterSlopeUnit", property);
		},
		toggleCutSettingSlopeUnit({ commit }, property) {
			commit("toggleCutSettingSlopeUnit", property);
		},
		toggleTrenchCutSettingSlopeUnit({ commit }, property) {
			commit("toggleTrenchCutSettingSlopeUnit", property);
		},
		toggleFillSettingSlopeUnit({ commit }, property) {
			commit("toggleFillSettingSlopeUnit", property);
		},
		toggleTrenchLongitudinalSlopeUnit({ commit }, property) {
			commit("toggleTrenchLongitudinalSlopeUnit", property);
		},
		updateIsLoading({ commit }, isLoading) {
			commit("setLoading", isLoading);
		},
		/**
		 * タスク実行前にスピナーを表示し、完了後に非表示にする
		 * @param {*} asyncTask
		 */
		async executeWithSpinner({ commit }, asyncTask) {
			return new Promise((resolve, reject) => {
				// ローディング開始
				commit("setLoading", true);
				// スピナー表示までラグがあるため処理開始を遅延させる
				setTimeout(async () => {
					try {
						await asyncTask();
					} catch (e) {
						reject(e);
					} finally {
						// ローディング終了
						commit("setLoading", false);
						resolve();
					}
				}, 100);
			});
		},
		setCurrentView({ state, commit }, view) {
			commit("set_current_view", view);
			if (view === "3d") {
				set3DView();
			} else if (view === "top") {
				// If an object is being edited, switch to a 2D view based on that object
				if (
					state.inProgressModeManager.inProgressMode === InProgressMode.EDIT &&
					state.inProgressModeManager.objectId
				) {
					setTopViewCameraToObject(state.inProgressModeManager.objectId);
				} else {
					// If no object is being edited, switch to a 2D view based on the current camera position
					set2DViewFromCurrentPosition();
				}
			}
		},
		requestViewerRender({ state }) {
			if (state.viewer) {
				state.viewer.requestRender();
			}
		},
	},
	getters: {
		lang: (state) => state.lang,

		terrainList(state) {
			const designList = state.design_list.filter(
				(design) => design.type === "design",
			);
			return [
				...state.point_cloud_list,
				...designList,
				...state.drawing2dImage.drawing2dImageList,
			];
		},
		visibleTerrainList(_state, getters) {
			return getters.terrainList.filter((terrain) => terrain.getVisibility());
		},
		pointCloudAndDesignList(_state, getters) {
			return getters.terrainList;
		},
		/**
		 * 現場の点群リストを返却する
		 * @param {*} state
		 * @returns PointCloud 表示中の点群リスト
		 */
		sitePointClouds: (state) => state.point_cloud_list,
		/**
		 * 表示中の点群リストを返却する
		 * @param {*} state
		 * @returns PointCloud 表示中の点群リスト
		 */
		visiblePointClouds: (state) =>
			state.point_cloud_list.filter((pointCloud) => pointCloud.getVisibility()),
		activePointCloud: (state) => {
			const pointClouds = state.point_cloud_list.filter((pointCloud) =>
				pointCloud.getVisibility(),
			);
			return pointClouds[0] || null;
		},
		visibleDesigns: (state) =>
			state.design_list.filter((Design) => Design.getVisibility()),
		designs: (state) => state.design_list,
		activeDesign: (state) => {
			const designs = state.design_list.filter((design) =>
				design.getVisibility(),
			);
			return designs[0] || null;
		},
		activePointCloudId: (state) => {
			const pointClouds = state.point_cloud_list.filter((pointCloud) =>
				pointCloud.getVisibility(),
			);
			const id = pointClouds[0]
				? Number.parseInt(pointClouds[0].asset_id)
				: undefined;
			return id;
		},
		viewer: (state): EarthBrainViewer => state.viewer,
		isLoading: (state) => state.isLoading,
		pointCloudCount: (state) => state.point_cloud_list.length,
		designDataCount: (state) => state.design_list.length,
		site: (state) => state.site,
		linearList: (state, getters, rootState) => {
			const linearList = [...rootState.arbitraryLine.arbitraryLineList];

			// Filter unlinked lines only (lines linked to roads/trenches shown in edit panel)
			const filteredList = linearList.filter(
				(line) => !line.sourceObjectId && !line.sourceObjectType,
			);

			// createdAtで昇順にソート
			filteredList.sort((a, b) => {
				const d1 = new Date(a.createdAt);
				const d2 = new Date(b.createdAt);
				if (d1 > d2) {
					return 1;
				} else if (d1 < d2) {
					return -1;
				} else {
					return 0;
				}
			});
			return filteredList;
		},
		is_crs_conversion_in_progress: (state) =>
			state.is_crs_conversion_in_progress,
		conflictCoordinateSystem: (state) => state.conflictCoordinateSystem,
	},
	modules: {
		dialogs,
		addRoadTerrainByAi,
		measurement,
		arbitraryLine,
		simaLine,
		lineWorksCrossSection,
		lineWorksCenterline,
		dxf,
		lock,
		drawing2dImage,
		object,
		inProgressModeManager,
		aiRoad,
		flatGround,
		solidMesh,
		spreadingCompaction,
		toolPanelActions,
	},
});

export default store;
